import { BackgroundSearchBody } from "./dtos/BackgroundAsset";
import { ContextType, DesignPackageListParams } from "./dtos/DesignPackage";

export const designKeys = {
  all: ["designPackages"] as const,
  list: (params: DesignPackageListParams) => ["designPackages", params] as const,
  listInfinite: (params: Omit<DesignPackageListParams, "page" | "cursor">) =>
    ["designPackages", "infinite", params] as const,
  detail: (id: number) => ["designPackage", id] as const,
  activity: (id: number) => ["designPackageActivity", id] as const,
  presence: (id: number) => ["designPackagePresence", id] as const,
  previews: (id: number, themeId: number | null, includeCandidates = false) =>
    ["designPackagePreviews", id, themeId, includeCandidates] as const,
  stats: (id: number) => ["designPackageStats", id] as const,
  trace: (id: number) => ["designPackageTrace", id] as const,
  /** Client-only: the background a coach is trying on a slide, shared by the tray and the large view. */
  triedBackground: (id: number) => ["designPackageTriedBackground", id] as const,
  renderGroup: (id: number) => ["renderGroup", id] as const,
  postableReviews: (playerId: number) => ["reviews", "postable", playerId] as const,
  reviewPosts: (reviewId: string | number) => ["reviewPosts", String(reviewId)] as const,
  availableDesigns: (playerId: number, contextType?: ContextType) =>
    ["designPackages", { scope: "available", playerId, contextType }] as const,
  renderGroupLookup: (designPackageId: number, playerId: number, reviewIds: number[]) =>
    ["renderGroupLookup", designPackageId, playerId, reviewIds.join(",")] as const,
  backgrounds: {
    all: ["backgroundAssets"] as const,
    search: (body: BackgroundSearchBody) => ["backgroundAssets", "search", body] as const,
    asset: (id: number) => ["backgroundAsset", id] as const,
    requests: (params: object) => ["backgroundRequests", params] as const,
    queue: ["backgroundsQueue"] as const,
  },
};
